import React from 'react';
import CountryIcon from '~/UI/CountryIcon';

export interface CountryWithSourceProps {
	countryAlpha: string;
	countryName: string;
	dataSourceShortName: string;
	showTooltip?: boolean;
}

export function CountryWithSource({
	countryAlpha,
	countryName,
	dataSourceShortName,
	showTooltip,
}: CountryWithSourceProps) {
	return (
		<div className='w-auto grow shrink flex flex-nowrap justify-start items-center'>
			<CountryIcon code={countryAlpha} name={countryName} />
			<div className='grow shrink w-0 pl-2'>
				<span className='block text-[14px] font-semibold leading-tight not-italic tracking-wider text-black'>
					{countryAlpha}
				</span>
				<span
					className={`block max-w-full text-[11px] leading-tight text-gray-500 tracking-wide truncate ${
						showTooltip && 'underline decoration-dotted transition group-hover:text-black'
					}`}
				>
					{dataSourceShortName}
				</span>
			</div>
		</div>
	);
}
